"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInfraStageFromDomain = void 0;
const getInfraStageFromDomain = (domain = window.location.hostname) => {
    if (/^(www\.)?(minhaloja\.|multimarcas\.)/.test(domain)) {
        return 'production';
    }
    return 'homologation';
};
exports.getInfraStageFromDomain = getInfraStageFromDomain;
